let mutations = {
    setBaseUrl(state, data) {
        // 变更base url
        state.url = data;
    }
}
export default mutations;


// WEBPACK FOOTER //
// ./src/vuex/modules/baseUrl/mutations.js